import { render, staticRenderFns } from "./AccordionWrapper.vue?vue&type=template&id=03c2fd06&scoped=true"
import script from "./AccordionWrapper.vue?vue&type=script&lang=js"
export * from "./AccordionWrapper.vue?vue&type=script&lang=js"
import style0 from "./AccordionWrapper.vue?vue&type=style&index=0&id=03c2fd06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c2fd06",
  null
  
)

export default component.exports